import { GessanBaseAPI } from "@/api/gessan.base.api";
import { VUE_APP_GESSAN_URL } from "@/commons/config";
import {
  MultaAdministrativa,
  MultaAdministrativaFilter,
} from "@/models/gessan/multaAdministrativa";
import { Pagination } from "@/models/sit-pedido/pagination";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";

export class MultaAdministrativaApi extends GessanBaseAPI<MultaAdministrativa> {
  constructor() {
    super();
    this.apiUrl = `${VUE_APP_GESSAN_URL}/centralServicos/multaAdministrativa`;
  }

  private normalizeDecimalParam(value?: string | number | null): number | null {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    const normalizedValue = value.toString().replaceAll(".", "").replaceAll(",", ".");
    const parsedValue = normalizedValue ? Number(normalizedValue) : null;

    return parsedValue !== null && !Number.isNaN(parsedValue) ? parsedValue : null;
  }

  private normalizeFilter(
    filter: MultaAdministrativaFilter
  ): MultaAdministrativaFilter {
    return {
      ...filter,
      cnpj: FunctionsCommuns.removeFormat(filter.cnpj),
      valorPrincipalDe: this.normalizeDecimalParam(filter.valorPrincipalDe),
      valorPrincipalAte: this.normalizeDecimalParam(filter.valorPrincipalAte),
      nup: filter.nup?.trim() || null,
      autoInfracao: filter.autoInfracao?.trim() || null,
      mesCompetencia: filter.mesCompetencia || null,
      dataVencimentoDe: filter.dataVencimentoDe || null,
      dataVencimentoAte: filter.dataVencimentoAte || null,
      sortBy: filter.sortBy || null,
      sortOrder: filter.sortOrder || null,
    };
  }

  public getList(
    filter: MultaAdministrativaFilter
  ): AxiosObservable<Pagination<MultaAdministrativa>> {
    return this.axios.get(`${this.apiUrl}/lista`, {
      params: this.normalizeFilter(filter),
    });
  }
}
